<template>
  <div>
    <div class="main-container" v-show="isShow">
      <a-tabs type="card" v-model="settlement.supplierTag" @change="callback" >
          <a-tab-pane key="1" tab="预付账户">
            <advancePaly/>
          </a-tab-pane>
          <a-tab-pane key="2" tab="后付账户">
            <afterPaly/>
          </a-tab-pane>
        </a-tabs>
    </div>
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
  
</template>
<script>
import afterPaly from "./afterPaly"
import advancePaly from "./advancePaly"
import {mapState} from 'vuex'
export default {
  components:{afterPaly,advancePaly},
  data() {
    return {};
  },
  computed: {
    ...mapState(['settlement']),
    isShow() {
      return this.$route.name === "supplier-account";
    },
  },
  created(){
    this.settlement.supplierTag = "1";
  },
  methods: {
    callback(key) {
      this.settlement.supplierTag=key;
    },
  },
};
</script>

<style lang="less" scoped>

</style>